import React from 'react';

/**
 * L'école dessinée de la page de connexion.
 *
 * Un dessin vectoriel écrit dans le code, et non une photo servie à part : il
 * s'affiche dans le même rendu que la page. Pas de téléchargement, pas de fond
 * noir le temps qu'une image arrive au rechargement — le défaut constaté sur la
 * page de connexion de HoraPilot, dont l'image est un JPG.
 *
 * Il se redimensionne sans perte (`preserveAspectRatio="xMidYMid slice"`) et
 * remplit toujours son cadre.
 */
const SceneEcole = ({ className = '' }) => (
  <svg
    className={className}
    viewBox="0 0 900 600"
    preserveAspectRatio="xMidYMid slice"
    aria-hidden="true"
    focusable="false"
  >
    <rect width="900" height="600" fill="#2a6f93" />
    <circle cx="720" cy="120" r="70" fill="#f0c36b" opacity=".9" />
    <path d="M0 420c120-40 240-40 360 0s240 40 360 0 180-20 180-20v200H0z" fill="#45A89F" opacity=".55" />

    {/* Le bâtiment de l'école */}
    <g transform="translate(250 150)">
      <rect x="0" y="120" width="400" height="220" fill="#f7f5ef" />
      <path d="M-20 125 200 20l220 105z" fill="#C06B58" />
      <rect x="160" y="60" width="80" height="60" fill="#f7f5ef" />
      <circle cx="200" cy="90" r="18" fill="#fff" stroke="#246990" strokeWidth="4" />
      <path d="M200 90v-10M200 90h8" stroke="#246990" strokeWidth="3" strokeLinecap="round" />
      <g fill="#3084b5">
        <rect x="30" y="160" width="60" height="50" rx="4" />
        <rect x="120" y="160" width="60" height="50" rx="4" />
        <rect x="220" y="160" width="60" height="50" rx="4" />
        <rect x="310" y="160" width="60" height="50" rx="4" />
      </g>
      <rect x="165" y="240" width="70" height="100" rx="6" fill="#1b4f6d" />
      <rect x="190" y="-30" width="4" height="60" fill="#1f2937" />
      <path d="M194-30h46l-10 14 10 14h-46z" fill="#45A89F" />
    </g>

    {/* Les arbres */}
    <g>
      <circle cx="140" cy="380" r="60" fill="#2f8a82" />
      <rect x="132" y="420" width="16" height="70" fill="#6b4a2f" />
      <circle cx="790" cy="400" r="50" fill="#2f8a82" />
      <rect x="783" y="430" width="14" height="60" fill="#6b4a2f" />
    </g>

    {/* Les élèves */}
    <g>
      <circle cx="330" cy="470" r="16" fill="#8d5a3c" />
      <rect x="316" y="486" width="28" height="44" rx="10" fill="#f0c36b" />
      <circle cx="560" cy="476" r="15" fill="#5c3a28" />
      <rect x="547" y="491" width="26" height="42" rx="10" fill="#C06B58" />
      <circle cx="600" cy="470" r="16" fill="#a36b47" />
      <rect x="586" y="486" width="28" height="44" rx="10" fill="#fff" />
    </g>
  </svg>
);

export default SceneEcole;
